<script setup lang="ts">
import ConnectionCheckView from '@/views/ConnectionCheckView.vue'
</script>

<template>
	<ConnectionCheckView />
</template>
